export enum GeneralJournalType {
Transaction,
Opening,
Adjusting,
Closing,
}
